import { Pipe, PipeTransform } from '@angular/core';

/** Formats a date string as YYYY-MM-DD HH:mm in the user's local timezone. */
@Pipe({ name: 'cloudDate' })
export class CloudDatePipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    if (!value) return '—';
    const d = new Date(value);
    if (isNaN(d.getTime())) return '—';
    const pad = (n: number) => String(n).padStart(2, '0');
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
  }
}
